const styles = {
  position: "absolute",
  clip: "rect(1px 1px 1px 1px)",
  clipPath: "inset(50%)",
  padding: 0,
  border: 0,
  height: "1px",
  width: "1px",
  overflow: "hidden",
  whiteSpace: "nowrap"
};
export {
  styles
};
